import { IFormBase, ReportItem } from "./index";

export enum Show {
    REPORT_TYPES = 'reportTypes',
    FORM = 'form',
    GENERATED_REPORTS = 'generatedReports',
    ALL_REPORTS = 'allReports'
  }

export interface FieldSet {
  type: string;
  name: string;
  legend: string;
  hint: string;
  required: number;
  fields: null | IFormBase<string>[];
}

export interface ReportPage {
    show: Show;
    title: string;
    fieldSets: FieldSet[];
    reportTypes: ReportItem[];
}
